import axios from 'axios';
import { DASHBOARD_API } from './service';

export const getExperiences = (query: any) => {
    const searchParams = new URLSearchParams(query).toString();
    const url = `${DASHBOARD_API}/experiences?${searchParams}`;
    const response = axios.get(url);
    return response;
};
